module.exports = __webpack_public_path__ + "static/media/ic_why_hs_gmc_1.f6bed2d1.svg";